import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { BorderBox } from 'ui-v2'

export const Route = createFileRoute(
  '/impact-kpis/_layout/investee-revenue-growth/supporting-metrics/',
)({
  component: InvesteeRevenueGrowthSupportingMetrics,
})

function InvesteeRevenueGrowthSupportingMetrics() {
  return <BorderBox>InvesteeRevenueGrowthSupportingMetrics</BorderBox>
}
